//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { iosInput } from '@/tools/index.js'
import { mapGetters } from 'vuex'
import rulePlaceholder from './mixins/rulePlaceholder'
import downloadImgs from '@/mixins/downloadImgs'
export default {
  data() {
    return {
      rule: {
        custom: {}
      }
    }
  },
  mixins: [rulePlaceholder, downloadImgs],
  props: {
    question: {
      type: Object,
      default() {
        return {}
      }
    },
    index: {
      type: Number
    },
    readonly: {
      type: Boolean
    },
    showScore: {
      type: Boolean,
      default: false,
    },
  },
  created() {
    this.question.options.forEach((item, index) => {
      item.name = `blank_multiple${index}`
      item.value = ''
    })
  },
  mounted() {
    const rule = {
      required: () => '请输入内容'
    }
    this.question.options.forEach(item => {
      this.rule.custom[item.name] = rule
    })
    console.log(this.rule)
    this.$validator.localize('zh_CN', this.rule)
    //已答的题挂上答案
    if (this.question.v_answer) {
      const options = this.question.v_answer.options
      options.forEach(item => {
        this.question.options.forEach(o => {
          if (item.tenantId == o.tenantId) {
            o.value = item.content
          }
        })
      })
    }
  },
  computed: {
    ...mapGetters(['questionnaireList'])
  },
  methods: {
    async onBlur(item) {
      iosInput()
      // 验证是否已经填写
      const check = await this.$validator.validateAll({
        [item.name]: item.value
      })
      if (!check) {
        return
      }
      let v_answered = false;
      if (this.question.required) {
        // 必填校验每个子选项表单
        v_answered = this.question.options.every(i => {
          return i.value
        });
      } else {
        // 非必填默认为true，可以提交
        v_answered = true;
      }
      const param = {
        index: this.index,
        v_answered
      }
      this.$store.commit('setQuestionAnswered', param)
      let v_answer = this.getValue()
      this.$store.commit('setQusstionUserAnswer', {
        index: this.index,
        v_answer
      })
    },
    getValidateRule(item) {
      var rules = []
      if (this.question.required) {
        rules.push('required')
      }
      let maxLength = item.blankMaxLength || 500
      if (
        maxLength &&
        item.value.length > maxLength &&
        item.blankRule !== 'number'
      ) {
        rules.push('max')
        rules.push(`max:${maxLength},${item.value.length}`)
      }
      if (item.blankRule !== 'ignore') {
        if (item.blankRule === 'number') {
          const min = !item.blankMinLength && String(item.blankMinLength) !== '0';
          const max = !item.blankMaxLength && String(item.blankMaxLength) !== '0';
          rules.push(`number`)
          rules.push(
            `between:${min ? -1000000000 : item.blankMinLength},${max ? 1000000000 : item.blankMaxLength}`
          )
        } else {
          rules.push(`${item.blankRule}`)
        }
      }

      if (item.blankMinLength && Number(item.blankMinLength) && item.blankRule !== 'number') {
        rules.push(`min:${Number(item.blankMinLength)}`)
      }
      return rules.join('|')
    },
    getValue() {
      const options = []
      this.question.options.forEach(item => {
        options.push({
          tenantId: item.tenantId,
          text: item.text,
          content: item.value
        })
      })
      return {
        tenantId: this.question.tenantId,
        type: 'blank_multiple',
        options: options
      }
    },
    async validate() {
      let promiseArray = []
      for (const option of this.question.options) {
        const validate = this.$validator.validateAll({
          [option.name]: option.value
        })
        promiseArray.push(validate)
      }
      const checkList = await Promise.all(promiseArray)
      console.log(checkList)
      return checkList.every(item => {
        return item
      })
    },
    onInputChange(item) {
      // let v_answer = this.getValue()
      // this.$store.commit('setQusstionUserAnswer', {
      //   index: this.index,
      //   v_answer
      // })
      // console.log(this.question);
    }
  }
}
